import React, { useState } from 'react'
import { useSnackbar } from 'notistack'
import { Modal, Popconfirm } from 'antd'
import { useSelector } from 'react-redux'

import { usePet, notifOps, stringifyDate } from '../../modules'

const OngoingShift = ({ toggle, visible, shifts, setShift, department }) => {
    const { enqueueSnackbar } = useSnackbar()

    const { user } = useSelector(state => state.application)

    const onSave = shift => {
        setShift(shift)
        enqueueSnackbar('Shift has been selected', notifOps('success'))
        setTimeout(toggle, 300)
    }

    const [, startShift] = usePet('startShift', { department }, { notify: true, callback: ({ data }) => onSave(data), manual: true, load: { msg: 'Starting new shift...' } })

    return (
        <Modal 
            width={ 500 }
            footer={ null }
            onCancel={ toggle }
            visible={ visible } 
            title="Select Shift">
            <div className="w-full text-center mb-3">
                {
                    shifts.length > 0 ?
                        <>
                            <p className="font-semibold text-lg">An ongoing shift by { shifts[0]?.user?.name } was found</p>
                            <p className="font-semibold text-sm">Started on { stringifyDate(shifts[0]?.date) }</p>
                        </>
                    : 
                        <p className="font-semibold text-lg">No open shifts at the moment</p>
                }
                <span className="flex items-center justify-center">
                    {
                        shifts.length > 0 &&
                        <button onClick={ () => onSave(shifts[0]) } className="text-white focus:ring-2 hisani-btn-green font-medium rounded-lg text-sm px-5 mr-3 py-2.5 text-center">Proceed with this shift</button>
                    }
                </span>
            </div>
        </Modal>
    )
}

export default OngoingShift